var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccularicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.8125C4.375 2.8125 1.70625 4.75625 0.625 7.5C1.70625 10.2438 4.375 12.1875 7.5 12.1875C10.625 12.1875 13.2937 10.2438 14.375 7.5C13.2937 4.75625 10.625 2.8125 7.5 2.8125ZM7.5 10.625C6.6712 10.625 5.87634 10.2958 5.29029 9.70971C4.70424 9.12366 4.375 8.3288 4.375 7.5C4.375 6.6712 4.70424 5.87634 5.29029 5.29029C5.87634 4.70424 6.6712 4.375 7.5 4.375C8.3288 4.375 9.12366 4.70424 9.70971 5.29029C10.2958 5.87634 10.625 6.6712 10.625 7.5C10.625 8.3288 10.2958 9.12366 9.70971 9.70971C9.12366 10.2958 8.3288 10.625 7.5 10.625ZM7.5 5.625C7.00272 5.625 6.52581 5.82254 6.17417 6.17417C5.82254 6.52581 5.625 7.00272 5.625 7.5C5.625 7.99728 5.82254 8.47419 6.17417 8.82583C6.52581 9.17746 7.00272 9.375 7.5 9.375C7.99728 9.375 8.47419 9.17746 8.82583 8.82583C9.17746 8.47419 9.375 7.99728 9.375 7.5C9.375 7.00272 9.17746 6.52581 8.82583 6.17417C8.47419 5.82254 7.99728 5.625 7.5 5.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccularicon);
export default __webpack_public_path__ + "static/media/occularicon.d6fd83051c15ae6b6affdaab61cdc888.svg";
export { ForwardRef as ReactComponent };